// extracted by mini-css-extract-plugin
module.exports = {"nav":"company-detail-section-navigator_component_nav__todXK"};